//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { frameTreeApi } from '@/api/public';
export default {
  name: 'manageRange',
  props: {
    all: {
      type: String,
      default: 'all'
    }
  },
  created: function created() {
    this.getScopeFrame();
    if (this.all) {}
  },
  data: function data() {
    return {
      frameTreeData: [],
      frame_id: this.all
    };
  },
  methods: {
    changeFrame: function changeFrame(e) {
      var id = e[e.length - 1];
      this.$emit('change', id);
    },
    getScopeFrame: function getScopeFrame() {
      var _this = this;
      var data = {
        scope: 1
      };
      frameTreeApi(data).then(function (res) {
        _this.frameTreeData = res.data;
      });
    },
    reset: function reset() {
      this.frame_id = this.all;
    }
  }
};